import React  from "react";
import { protected_api_call, tab_filter_url, patient_filter_url } from "../api/api";
import { VscLoading } from "react-icons/vsc";
import { Link } from 'react-router-dom'


class UnscheduledPatients extends React.Component {

    state = {
        results: [],
        first_name: "",
        last_name: "",
        dob: "",
    }

    filterFormField = []

    submit = async () => {
        let data = {
            "hospital": "None", "diagnosis": "None",
            "criticality": "None", "insurance": "None",
            "esrd": "None", "references": "None",
            "sfreq": "None", "scheduled_date": "",
            "comments": "", "created_at": "",
            "created_by": "", "FirstName": this.state["first_name"], 
            "LastName": this.state["last_name"], "DateOfBirth": this.state["dob"], "ScheduledBoolean": "Not Scheduled"
        }
        
        this.setState({loading: true})

        let response = await protected_api_call(patient_filter_url, data)
        if(response.status === 200 || response.status === 201) {
            let resp = await response.json()
            console.log(resp)
            this.setState({results: resp["data"], loading: false})
        } else {
            this.setState({loading: false})
            alert("Server Error")
        }   
    }

    componentDidMount = async () => {

        let response = await protected_api_call(tab_filter_url, {"ScheduledBoolean": "Not Scheduled"} ,"POST")
        if(response.status === 200 || response.status === 201) {
            let resp = await response.json()
            console.log(resp)
            this.setState({results: resp["data"], loading: false})
        } else {
            this.setState({loading: false})
            alert("Server Error")
        }
    
      this.filterFormField = [
        {
            "name": "First Name",
            "id_name": "first_name",
            "type": "text"
        },
        {
            "name": "Last Name",
            "id_name": "last_name",
            "type": "text"
        },
        {
            "name": "DOB",
            "id_name": "dob",
            "type": "date"
        }

      ]
      this.setState({})
    }

    render() {
        console.log(this.state.userinfo)
        return (
            <>
                <div className=' w-full flex justify-between'>
                    <h1 className='font-semibold text-lg sm:text-xl py-2 text-center md:text-4xl heading text-purple-600 mb-2'>
                        Unscheduled Patients
                    </h1>
                </div>

                <div className='flex flex-wrap justify-center '>
                    {this.filterFormField.map((data, key) => (
                    data.type === "dropdown" ? (
                        <>
                        <div className='flex flex-col p-2 border border-gray-600 rounded  m-2 w-1/3 '>
                            <h1 className='text-purplegray-900 mb-2'>{data.name}</h1>
                            <select
                                className='bg-purple-200 text-gray-700 appearance-none py-2 px-3 border rounded focus:bg-purple-50 focus:border-gray-400 focus:shadow-outline focus:outline-none'
                                value={this.state[data.id_name]}
                                onChange = {e => this.setState({[data.id_name]: e.target.value})}>
                                <option value="None">None</option>
                                {data.options.map((option, key) => (
                                    <option key={key} value={option}>{option}</option>
                                ))}
                            </select>
                        </div>
                        </>
                    ) : (
                        <div className='flex flex-col p-2 border border-gray-600 rounded  m-2 w-1/3 '>
                            <h1 className='text-purplegray-900 mb-2'>{data.name}</h1>
                            <input
                                className='bg-purple-200 text-gray-700 appearance-none py-2 px-3 border rounded focus:bg-purple-50 focus:border-gray-400 focus:shadow-outline focus:outline-none'
                                type={data.type}
                                value={this.state[data.id_name]}
                                onChange = {e => this.setState({[data.id_name]: e.target.value})}
                            />
                        </div>
                    )
                    ))}
                </div>

                <div className="w-full flex flex-col items-center mt-5 mb-10">
                    <button
                        type="submit"
                        className="w-1/3 h-12 flex justify-center items-center rounded-lg bg-purple-600 text-purplegray-100 text-lg hover:shadow-md"
                        onClick={this.submit}
                        >
                        {this.state.loading ? <VscLoading className='w-6 h-6 animate-spin' /> : <h1>Filter</h1>}
                    </button>
                </div>

                {
                    this.state.results.length == 0 ? (
                        <div className='grid mt-10 place-items-center'>
                            <h1 className='text-2xl font-bold border text-purple-800  border-purple-300 px-10 py-2 rounded-lg  bg-purple-200'>NO RESULTS FOUND</h1>
                        </div>
                    ) : (
                        <>

                            {this.state.results.map((data, key) => (
                                <div className='flex justify-between items-center bg-purple-200 p-4 rounded-lg my-3 border border-purple-300 rounded-lg'>
                                    <h1>Name: {data.FirstName + ' ' + data.LastName}</h1>
                                    <h1>Hospital: {data.Hospital}</h1>
                                    <h1>Diagnosis: {data.Diagonosis}</h1>
                                    <h1>Criticality: {data.Criticality}</h1>
                                    <h1>Insurance: {data.Insurance}</h1>
                                    {/* <h1> Village: {data.NativeVillage === "" ? "NA" : data.NativeVillage} </h1> */}
                                    <div>
                                        {/* <Link to={`/form/auth_${data.ApplicationID}`} state={{ "userinfo": data }} className='bg-green-600 mr-3 p-2 rounded-lg text-white text-center'>
                                            UPDATE
                                        </Link> */}
                                        <Link onClick={(event) => {}} target="_blank" rel="noopener noreferrer" to={`/info/${data.id}`} state={{"userinfo": data}} className='bg-purple-900 p-2 rounded-lg text-white text-center'>
                                            INFO
                                        </Link>
                                    </div>
                                </div>
                            ))}
                        </>       
                    )
                }
            </>
        )
    }
}

export default UnscheduledPatients;